<template>
  <div class="main" id="infoCenter">
    <Nav />
    <div class="banner">
      <p>— 奖品兑换及券包领用情况 —</p>
      <img src="../images/banner3.png" alt="" />
    </div>
    <div class="banner-mobile">
      <p>— 奖品兑换及券包领用情况 —</p>
      <div class="toutu">
        <div class="item card1">
          <img src="../images/cardicon1.png" alt="" />
          <span class="text1">可用积分</span>
          <span class="text2">{{ currentPoints }}</span>
        </div>
        <div class="item card2">
          <img src="../images/cardicon2.png" alt="" />
          <span class="text1">已兑奖品</span>
          <span class="text2">{{ prizeNum }}份</span>
        </div>
        <div class="item card3">
          <img src="../images/cardicon3.png" alt="" />
          <span class="text1">券包分享</span>
          <span class="text2">{{ shareNum }}人</span>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <img class="bg1" src="../images/bg1.png" alt="" />
      <img class="bg2" src="../images/bg2.png" alt="" />
      <div class="toutu">
        <div class="item card1">
          <img src="../images/cardicon1.png" alt="" />
          <span class="text1">可用积分</span>
          <span class="text2">{{ currentPoints }}</span>
        </div>
        <div class="item card2">
          <img src="../images/cardicon2.png" alt="" />
          <span class="text1">已兑奖品</span>
          <span class="text2">{{ prizeNum }}份</span>
        </div>
        <div class="item card3">
          <img src="../images/cardicon3.png" alt="" />
          <span class="text1">券包分享</span>
          <span class="text2">{{ shareNum }}人</span>
        </div>
      </div>
      <div class="gift">
        <p class="title">我的已兑奖品</p>
        <div class="content" v-if="prizeList.length != 0">
          <div class="item" v-for="item in prizeList" :key="item.index">
            <img :src="item.imgUrl" alt="" />
            <span class="text1">{{ item.price }}元京东卡</span>
            <span class="text2"
              >价值 <span>￥{{ item.price }}</span></span
            >
            <span class="text3">{{ item.num }}份</span>
          </div>
        </div>
        <div class="content" v-else>
          <div class="none">
            <img src="../images/none.png" alt="" />
            <span>您还没有获得奖品</span>
          </div>
        </div>
      </div>
      <div class="info">
        <p class="title">专属券包领用情况</p>
        <div class="content" v-if="shareList.length != 0">
          <div class="item" v-for="item in shareList" :key="item.index">
            <img src="../images/friend.png" alt="" />
            <span class="text1">好友{{ item.phone }}</span>
            <span class="text2">已领取{{ item.quantity }}份</span> 
            <span class="text3"
              >已使用 <span>{{ item.num }}</span> 张券</span
            >
            <span class="text4"
              >您已获积分<span>{{ item.points }}</span></span
            >
          </div>
        </div>
        <div class="content" v-else>
          <div class="none">
            <img src="../images/none.png" alt="" />
            <span>您还没有券包分享记录</span>
          </div>
        </div>
      </div>
      <div class="contact">
        <p class="text1">联系官方虹助手领取奖品</p>
        <img src="../images/qrcode.png" alt="" />
        <p class="text2">奖品在活动结束审核无误后30个工作日内发放</p>
      </div>
    </div>
    <div class="wrapper-mobile">
      <div class="gift">
        <p class="title">我的已兑奖品</p>
        <div class="content" v-if="prizeList.length != 0">
          <div class="item" v-for="item in prizeList" :key="item.index">
            <span class="text1">{{ item.price }}元京东卡</span>
            <span class="text2"
              >价值 <span>￥{{ item.price }}</span></span
            >
            <span class="text3">{{ item.num }}份</span>
          </div>
        </div>
        <div class="content" v-else>
          <div class="none">
            <img src="../images/none.png" alt="" />
            <span>您还没有获得奖品</span>
          </div>
        </div>
      </div>
      <div class="info">
        <p class="title">专属券包领用情况</p>
        <div class="content" v-if="shareList.length != 0">
          <div class="item" v-for="item in shareList" :key="item.index">
            <div class="user">
              <img src="../images/friend.png" alt="" />
              <span class="text">好友{{ item.phone }}</span>
            </div>
            <div class="cc">
              <span class="text1">已领取{{ item.quantity }}份</span>
              <span class="text2">已使用 {{ item.num }}张券</span>
              <span class="text3">您已获积分 {{ item.points }}</span>
            </div>
          </div>
        </div>
        <div class="content" v-else>
          <div class="none">
            <img src="../images/none.png" alt="" />
            <span>您还没有券包分享记录</span>
          </div>
        </div>
      </div>
      <div class="contact">
        <p class="text1">联系官方虹助手领取奖品</p>
        <img src="../images/qrcode.png" alt="" />
        <p class="text2">奖品在活动结束审核无误后30个工作日内发放</p>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../components/nav.vue";
export default {
  name: "Detail",
  components: { Nav },
  data() {
    return {
      currentPoints: 0,
      prizeNum: 0,
      shareNum: 0,
      prizeList: [],
      shareList: [],
    };
  },
  created() {
    this.getPointsDetail();
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  mounted() {
    let _this = this;
    _this.$nextTick(function () {
      window.addEventListener("scroll", _this.handleScroll);
    });
  },
  methods: {
    toLocal() {
      //查找存储的锚点id
      let Id = localStorage.getItem("toId");
      let toElement = document.getElementById(Id);
      //锚点存在跳转
      if (Id) {
        toElement.scrollIntoView();
      }
    },
    async getPointsDetail() {
      let { data } = await this.$axios.post(
        "/operator/recommend/getPointsInfo",
        {
          remark: 202109,
        }
      );
      if (data.success == true && data.retMsg == "ok") {
        this.currentPoints = data.retObj.currentPoints;
        let map = data.retObj.exchangeList;
        let tmpList = [];
        for(var key in map){
          tmpList.push([key, map[key]])
        }
        this.shareNum = data.retObj.extensionUsers
          ? data.retObj.extensionUsers.length
          : 0;
        let imgUrl = "";
        tmpList.forEach((item, index) => {
          item[0] = parseInt(item[0]);
          this.prizeNum += item[1];
          if (item[0] >= 5000) {
            imgUrl = require("../images/c1.png");
          } else if (item[0] < 5000 && item[0] >= 1000) {
            imgUrl = require("../images/c2.png");
          } else if (item[0] < 1000 && item[0] >= 500) {
            imgUrl = require("../images/c3.png");
          } else {
            imgUrl = require("../images/c4.png");
          }
          this.prizeList.push({
            index: index,
            imgUrl: imgUrl,
            price: item[0],
            num: item[1]
          });
        });
        data.retObj.extensionUsers.forEach((item) => {
          this.shareList.push({
            phone: item.phone,
            quantity: item.receiveCount,
            num: item.useCount,
            points: item.points,
          });
        });
      }
    },
  },
  //用完后记得将存储的锚点置空，否则会影响其他页面跳转到当前页面
  destroyed() {
    localStorage.setItem("toId", "");
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  position: relative;
  overflow: hidden;
  .banner {
    display: block;
    position: relative;
    p {
      font-size: 40px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 68px;
      letter-spacing: 2px;
      color: #ffffff;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 100px;
    }
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  .banner-mobile {
    display: none;
  }
  .wrapper-mobile {
    display: none;
  }
  .wrapper {
    width: 100%;
    position: relative;
    background-color: #1e0050;
    padding-top: 80px;
    position: relative;
    .bg1 {
      position: absolute;
      right: -120px;
      top: 400px;
      z-index: 1;
    }
    .bg2 {
      position: absolute;
      top: 287px;
      left: -80px;
    }
    .toutu {
      width: 1024px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -145px;
      .item {
        width: 320px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 3px 30px 0px #6f43ff;
        border-radius: 8px;
        background-position: center;
        background-size: 100% auto;
        background-repeat: no-repeat;
        img {
          margin-top: 20px;
        }
        .text1 {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 49px;
          letter-spacing: 1px;
          color: #ffffff;
          margin-left: 5px;
          margin-top: 20px;
        }
        .text2 {
          font-size: 40px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 49px;
          letter-spacing: 0px;
          color: #ffffff;
          margin-left: 8px;
        }
      }
      .item:not(:last-child) {
        margin-right: 34px;
      }
      .item.card1 {
        background-image: url(../images/card1.png);
      }
      .item.card2 {
        background-image: url(../images/card2.png);
      }
      .item.card3 {
        background-image: url(../images/card3.png);
      }
    }
    .gift {
      margin-top: 120px;
      .title {
        width: 175px;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: 1px;
        color: #ffffff;
        margin: 0 auto;
      }
      .content {
        width: 1024px;
        margin: 60px auto 0;
        background-color: rgba(255, 255, 255, 0.1);
        .item {
          display: flex;
          align-items: center;
          height: 120px;
          border-top: 1px solid #fed590;
          img {
            width: 135px;
            margin-left: 80px;
          }
          .text1 {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 120px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 120px;
            display: inline-block;
            width: 120px;
          }
          .text2 {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 120px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 80px;
            display: inline-block;
            width: 125px;
            span {
              font-size: 20px;
            }
          }
          .text3 {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 120px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 239px;
          }
        }
        .item:first-child {
          border-top: none;
        }
        .none {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 120px;
          img {
            width: 50px;
          }
          span {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 17px;
          }
        }
      }
    }
    .info {
      margin-top: 120px;
      .title {
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #ffffff;
        margin: 0 auto;
        text-align: center;
      }
      .content {
        width: 1024px;
        margin: 60px auto 0;
        background-color: rgba(255, 255, 255, 0.1);
        .item {
          display: flex;
          align-items: center;
          height: 120px;
          border-top: 1px solid #fed590;
          img {
            width: 40px;
            height: 40px;
            margin-left: 80px;
          }
          .text1 {
            margin-left: 10px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 120px;
            letter-spacing: 1px;
            color: #ffffff;
            display: inline-block;
            width: 185px;
          }
          .text2 {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 60px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 70px;
            display: inline-block;
            width: 110px;
          }
          .text3 {
            margin-left: 85px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 60px;
            letter-spacing: 1px;
            color: #ffffff;
            display: inline-block;
            width: 135px;
            span {
              font-size: 20px;
            }
          }
          .text4 {
            margin-left: 90px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 60px;
            letter-spacing: 1px;
            color: #ffffff;
            span {
              font-size: 20px;
            }
          }
        }
        .item:first-child {
          border-top: none;
        }
        .none {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 120px;
          img {
            width: 50px;
          }
          span {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 17px;
          }
        }
      }
    }
    .contact {
      width: 100%;
      margin-top: 120px;
      padding-bottom: 100px;
      .text1 {
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: 1px;
        color: #ffffff;
        text-align: center;
      }
      img {
        display: block;
        width: 300px;
        height: 300px;
        margin: 40px auto;
      }
      .text2 {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: 1px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .main {
    .banner {
      display: none;
    }
    .banner-mobile {
      position: relative;
      display: block;
      height: 160px;
      background-image: url("../images/banner3.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      p {
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 34px;
        letter-spacing: 1px;
        color: #ffffff;
        text-align: center;
        margin: 0 auto;
        padding-top: 70px;
      }
      .toutu {
        width: 100%;
        position: absolute;
        top: 132px;
        z-index: 1;
        .item {
          width: 293px;
          height: 110px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0px 3px 30px 0px #6f43ff;
          border-radius: 8px;
          background-position: center;
          background-size: 100% auto;
          background-repeat: no-repeat;
          img {
            margin-top: 20px;
          }
          .text1 {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 49px;
            letter-spacing: 1px;
            color: #ffffff;
            margin-left: 5px;
            margin-top: 20px;
          }
          .text2 {
            font-size: 40px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 49px;
            letter-spacing: 0px;
            color: #ffffff;
            margin-left: 8px;
          }
        }
        .item.card1 {
          background-image: url(../images/card1.png);
          margin-bottom: 20px;
        }
        .item.card2 {
          background-image: url(../images/card2.png);
          margin-bottom: 20px;
        }
        .item.card3 {
          background-image: url(../images/card3.png);
        }
      }
    }
    .wrapper {
      display: none;
    }
    .wrapper-mobile {
      width: 100%;
      background-color: #1e0050;
      display: block;
      position: relative;
      padding-top: 442px;
      .gift {
        width: 100%;
        .title {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
        }
        .content {
          width: 100%;
          margin-top: 40px;
          background-color: rgba(255, 255, 255, 0.1);
          .item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 48px;
            border-top: 1px solid #fed590;
            .text1 {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 48px;
              letter-spacing: 1px;
              color: #ffffff;
              display: inline-block;
              width: 86px;
            }
            .text2 {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 48px;
              letter-spacing: 1px;
              color: #ffffff;
              margin-left: 34px;
              display: inline-block;
              width: 76px;
            }
            .text3 {
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 48px;
              letter-spacing: 1px;
              color: #ffffff;
              margin-left: 57px;
              display: inline-block;
              width: 26px;
            }
          }
          .item:first-child {
            border-top: none;
          }
          .none {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 96px;
            img {
              width: 50px;
            }
            span {
              margin-left: 17px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 60px;
              letter-spacing: 1px;
              color: #ffffff;
            }
          }
        }
      }
      .info {
        width: 100%;
        margin-top: 80px;
        .title {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
        }
        .content {
          width: 100%;
          margin-top: 40px;
          background-color: rgba(255, 255, 255, 0.1);
          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: baseline;
            height: 80px;
            border-top: 1px solid #fed590;
            padding-left: 50px;
            .user {
              display: flex;
              align-items: center;
              margin-top: 17px;
              img {
                width: 17px;
                height: 17px;
              }
              span {
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 1px;
                color: #ffffff;
                margin-left: 5px;
              }
            }
            .cc {
              display: flex;
              justify-content: center;
              align-items: center;
              .text1 {
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 48px;
                letter-spacing: 1px;
                color: #ffffff;
                display: inline-block;
                width: 85px;
              }
              .text2 {
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 48px;
                letter-spacing: 1px;
                color: #ffffff;
                margin-left: 7px;
                display: inline-block;
                width: 100px;
              }
              .text3 {
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 48px;
                letter-spacing: 1px;
                color: #ffffff;
                margin-left: 5px;
              }
            }
          }
          .item:first-child {
            border-top: none;
          }
          .none {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 96px;
            img {
              width: 50px;
            }
            span {
              margin-left: 17px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 60px;
              letter-spacing: 1px;
              color: #ffffff;
            }
          }
        }
      }
      .contact {
        width: 100%;
        margin-top: 80px;
        padding-bottom: 80px;
        .text1 {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 60px;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
        }
        img {
          width: 280px;
          height: 280px;
          display: block;
          margin: 40px auto;
        }
        .text2 {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
</style>